/**
 * In-home support kinds (0235), the browser twin of
 * api/_shared/inHomeSupportKinds.ts: the nine kinds in the card's order,
 * the two that are not help at home, and the words the card and the dialog
 * show for each.
 */

/** The nine kinds, in the card's order (client_in_home_support_kind_check). */
export const IN_HOME_SUPPORT_KINDS = [
  'lives_alone',
  'no_support',
  'hourly_hha',
  'live_in_hha',
  'visiting_nurse_pt_ot',
  'family_caregiver',
  'private_caregiver',
  'home_care_agency_caregiver',
  'other',
] as const;

export type InHomeSupportKind = (typeof IN_HOME_SUPPORT_KINDS)[number];

/** The kinds that are not help at home: they take no provider, and No
 *  in-home support may sit beside them only. */
export const IN_HOME_SUPPORT_NOT_HELP: readonly InHomeSupportKind[] = ['lives_alone', 'no_support'];

/** Each kind's words on the card and beside its tick box. */
export const IN_HOME_SUPPORT_KIND_WORDS: Readonly<Record<InHomeSupportKind, string>> = {
  lives_alone: 'Lives alone',
  no_support: 'No in-home support',
  hourly_hha: 'Hourly HHA',
  live_in_hha: 'Live-in HHA',
  visiting_nurse_pt_ot: 'Visiting Nurse / PT / OT',
  family_caregiver: 'Family Caregiver',
  private_caregiver: 'Private Caregiver',
  home_care_agency_caregiver: 'Home Care Agency Caregiver',
  other: 'Other',
};

/** One entry of the door's body, every key present. */
export interface InHomeSupportKindInput {
  kind: InHomeSupportKind;
  provider_org_id: string | null;
  provider_individual_id: string | null;
  provider_text: string | null;
  note: string | null;
}
